// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';

import useAnalytics from 'Hooks/useAnalytics';
import useModals from 'Hooks/useModals';
import ModalManager from 'Containers/ModalManager/ModalManager';
import ExternalSupplierModalComponent from 'Components/Product/ExternalSupplierModal';

const ExternalSupplierModal = memo(() => {
  const modalContext = useModals();
  const analytics = useAnalytics();
  const { key, state } = modalContext.modalState.ADD_EXTERNAL_SUPPLIER_PRODUCT_TO_CART;
  const { product: selectedProduct, open: modalOpen, onConfirm } = state;

  const handleClose = () => {
    modalContext.setState(key, { open: false, product: null, onConfirm: null });
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (onConfirm) {
      analytics.track('external_supplier_product_add_to_cart');
      onConfirm();
    }
    handleClose();
  };

  return (
    <ModalManager open={ modalOpen }>
      <ExternalSupplierModalComponent
        open={ modalOpen }
        product={ selectedProduct || {} }
        onClose={ () => {
          analytics.track('external_supplier_product_add_to_cart_cancelled');
          handleClose();
        } }
        onSubmit={ handleSubmit }
      />
    </ModalManager>
  );
});

ExternalSupplierModal.displayName = 'ExternalSupplierModalContainer';

export default ExternalSupplierModal;
